export default function StationWidget({ station }: any) {
  return (
    <div className="col-span-12 sm:col-span-12 md:col-span-12 bg-white flex flex-col justify-start border rounded-md">
      <div className="text-lg px-4  border-b w-full text-gray-900  mb-2 text-center flex justify-between items-center rounded-t-md bg-blue-50">
        <div className="truncate uppercase font-bold">{station?.stationId}</div>
        <div className="border-l pl-2 text-red-600 font-bold">
          {station?.data?.length}
        </div>
      </div>
      <div className="grid grid-cols-12 gap-2  bg-white px-2 py-2">
        {station?.data?.map((visit: any) => (
          <div className="col-span-1 sm:col-span-1 md:col-span-1 bg-gray-100">
            <div className="mx-2 bg-gray-100 py-2 text-gray-800 font-bold text-sm text-center truncate">
              {visit?.vehicle?.registration}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
